import { render, staticRenderFns } from "./restname.vue?vue&type=template&id=04e9d2ea&scoped=true&"
import script from "./restname.vue?vue&type=script&lang=js&"
export * from "./restname.vue?vue&type=script&lang=js&"
import style0 from "./restname.vue?vue&type=style&index=0&id=04e9d2ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e9d2ea",
  null
  
)

export default component.exports